import { gql } from '@apollo/client'

export default gql(`
    mutation updateImageType( $id: ID! $enabledAssetTypes: [ImageAssetTypeInput] $aspectRatios: [ImageAspectRatioInput] $name: String! $position: Int $usageCount: Int $project: String) {
        updateImageType(
            input: {
                id: $id
                enabledAssetTypes: $enabledAssetTypes
                aspectRatios: $aspectRatios
                name: $name
                position: $position
                usageCount: $usageCount
            }
            project: $project
        ) {
            id
            name
            isDefault
            position
            isActive
            usageCount
            enabledAssetTypes{
                cropPosition
                assetType
                minCount
            }
            aspectRatios{
                aspectRatio
                name
                ratio
                title
                resolutions{
                    id
                    width
                    height
                    key
                }
            }
            updatedAt
            createdAt
        }
    }`
)
